/*
 * Shipping protection toggle for the cart drawer.
 * Toggling ON adds the insurance variant to the cart, OFF removes it.
 * No page reload: cart sections are re-rendered via the AJAX cart API.
 */
(function () {
  const OPTOUT_KEY = 'shipping_protection_optout';
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function applySections(sections) {
    if (!sections) return;

    // Replace the cart drawer body.
    if (sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const newInner = doc.querySelector('#CartDrawer');
      const oldInner = document.querySelector('#CartDrawer');
      if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;

      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.toggle('is-empty', !!doc.querySelector('.is-empty'));

      // innerHTML replace makes a fresh overlay node — re-bind close-on-click.
      const overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay && drawer) overlay.addEventListener('click', () => drawer.close());
    }

    // Replace the header cart count bubble.
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section');
        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
      }
    }
  }

  async function cartRequest(endpoint, body) {
    if (window.__spBusy) return;
    window.__spBusy = true;
    const el = document.querySelector('shipping-protection');
    if (el) el.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(rootUrl() + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: SECTIONS }, body)),
      });
      const data = await res.json();
      applySections(data.sections);
    } catch (e) {
      console.error('[shipping-protection]', e);
    } finally {
      window.__spBusy = false;
    }
  }

  async function addProtection(variantId) {
    if (window.__spBusy) return;
    try {
      const res = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const line = cart.items.find((i) => i.id === variantId || i.variant_id === variantId);
      if (line) {
        // Already in cart — never add a second one. Clamp to exactly 1 if duplicated.
        if (line.quantity === 1) return;
        return cartRequest('cart/change.js', { id: line.key, quantity: 1 });
      }
    } catch (e) {
      console.error('[shipping-protection]', e);
    }
    return cartRequest('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
  }

  async function removeProtection(variantId) {
    if (window.__spBusy) return;
    let key = variantId;
    try {
      const res = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const line = cart.items.find((i) => i.id === variantId || i.variant_id === variantId);
      if (!line) return; // already gone
      key = line.key; // line key removes reliably; raw variant id does not
    } catch (e) {
      console.error('[shipping-protection]', e);
    }
    return cartRequest('cart/change.js', { id: key, quantity: 0 });
  }

  class ShippingProtection extends HTMLElement {
    connectedCallback() {
      this.variantId = parseInt(this.dataset.variantId, 10);
      this.defaultOn = this.dataset.defaultOn === 'true';
      this.input = this.querySelector('.shipping-protection__input');

      if (!this.variantId || !this.input) return;

      this.input.addEventListener('change', this.onChange.bind(this));
      this.syncState();
    }

    // Authoritative state from the real cart, not the Liquid render.
    async syncState() {
      if (window.__spBusy) return;
      try {
        const res = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        const line = cart.items.find((i) => i.id === this.variantId || i.variant_id === this.variantId);
        const others = cart.items.filter((i) => !(i.id === this.variantId || i.variant_id === this.variantId));

        // Only protection left (no real products) — drop it so cart goes empty.
        if (line && others.length === 0) {
          cartRequest('cart/change.js', { id: line.key, quantity: 0 });
          return;
        }

        // Enforce exactly one — never let a duplicate quantity persist.
        if (line && line.quantity !== 1) {
          this.input.checked = true;
          cartRequest('cart/change.js', { id: line.key, quantity: 1 });
          return;
        }

        this.input.checked = !!line;

        const optedOut = localStorage.getItem(OPTOUT_KEY) === '1';
        if (!line && this.defaultOn && !optedOut && !window.__spBusy) {
          addProtection(this.variantId);
        }
      } catch (e) {
        console.error('[shipping-protection]', e);
      }
    }

    onChange(e) {
      if (e.target.checked) {
        localStorage.removeItem(OPTOUT_KEY);
        addProtection(this.variantId);
      } else {
        localStorage.setItem(OPTOUT_KEY, '1');
        removeProtection(this.variantId);
      }
    }
  }

  if (!customElements.get('shipping-protection')) {
    customElements.define('shipping-protection', ShippingProtection);
  }
})();
